import { useQuery } from 'react-query';
import { model, InviteClientResponse } from './inviteClient';

export const queryKey = () => ['email-template'];
export const useInviteClient = () => useQuery<InviteClientResponse>(queryKey(), () => model.get());
